import React, { useState } from "react";
import { ListGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { _t } from "app/i18n/i18n";
import { getPathname } from "lib/routing";
import { getGRP_JAPI_Url } from "utils/htmlReportsUtils";
import { KeywordSuggestions } from "../SearchBar/KeywordSuggestions";
import { getParam, gotoSearchResultsPage, push, addParam, setParam } from "../../api/search/filterUrlMaker";
import { SearchBar } from "../SearchBar/SearchBar";
import { JAPIAutoCompleteLoader } from "../../api/publications/JAPIAutoCompleteLoader";

export function AutoCompleteSearchBox(props) {
  const defaultKeyword = isLatestResearchPage() ? getParam("q") || getParam("title") || "" : "";
  const [keyword, setKeyword] = useState(defaultKeyword);
  const [acVisible, setAcVisible] = useState(false);
  const isTitleOnly = useSelector((state) => state.searchbar.isTitleOnly);

  return (
    <>
      <SearchBar
        {...props}
        keyword={keyword}
        onChange={(ev) => {
          setAcVisible(true);
          setKeyword(ev.target.value);
        }}
        onFocus={() => (keyword ? setAcVisible(true) : null)}
        onBlur={() => {
          setAcVisible(false);
          return 99;
        }}
        searchField={isTitleOnly ? "title" : "q"}
      />

      {acVisible && (
        <JAPIAutoCompleteLoader
          keyword={keyword}
          render={(suggestions) => (
            <ListGroup className="text-dark pb-3" variant="flush">
              <KeywordSuggestions keyword={keyword} setKeyword={setKeyword} onSubmit={props.onSubmit} />

              {suggestions.length > 0 &&
                suggestions.map((suggestion, key) => (
                  <Suggestion key={key} suggestion={suggestion} setKeyword={setKeyword} onSubmit={props.onSubmit} />
                ))}
            </ListGroup>
          )}
        />
      )}
    </>
  );
}

export function Suggestion({ suggestion, setKeyword, forHtmlReport, onSubmit, nairaMode, onNairaSearch }) {
  return isLabel(suggestion) ? (
    <ListGroup.Item className="h4 font-weight-lighter pl-2 pb-2 pt-3 mb-0">
      {_t(suggestion.label || suggestion.CategoryValue)}
    </ListGroup.Item>
  ) : (
    <ListGroup.Item
      as="a"
      onMouseDown={() => {
        if (onSubmit) {
          onSubmit(suggestion.CategoryName, suggestion.CategoryValue);
        }
        else if (nairaMode && onNairaSearch) {
          setKeyword("");
          const valueForNaira = suggestion.CategoryValue.replace(/^"|"$/g, "");
          onNairaSearch(valueForNaira);
        }
        else {
          onAutoCompleteClick(suggestion, setKeyword, forHtmlReport);
        }
      }}
      className="cursor-pointer py-1"
    >
      {suggestion.label || suggestion.CategoryValue}
    </ListGroup.Item>
  );
}

const onAutoCompleteClick = (suggestion, setKeyword, forHtmlReport) => {
  const category = suggestion.CategoryName || "q";
  const categoryWithLang = category + (suggestion.CategoryLang && suggestion.CategoryLang === "ja" ? "-JA" : "");
  setKeyword("");

  if (isLatestResearchPage()) {
    gotoSearchResultsPage(categoryWithLang, suggestion.CategoryValue);
  } else {
    // search page or others
    const page1 = setParam("From", 1);
    return forHtmlReport
      ? window.open(`${getGRP_JAPI_Url()}/research/m/Home?${categoryWithLang}=${suggestion.CategoryValue}`)
      : push(addParam(categoryWithLang, suggestion.CategoryValue, page1));
  }
};

const isLatestResearchPage = () => {
  const pathname = getPathname();
  return pathname.includes("/latest-research") || pathname === "/" || pathname === "";
};

const isLabel = (suggestion) =>
  ["Label", "Companies", "Analysts", "Periodicals", "Themes"].includes(suggestion.CategoryName);
